export const NO_INFO = '---';

export function dashOnNoInfo(input: string | number | boolean | null | undefined): string | number | boolean {
  return input === '' ? NO_INFO : input ?? NO_INFO;
}
